import { auth } from '../firebase';

export const API_BASE_URL = process.env.REACT_APP_GOTTEA_API_BASE_URL || 'https://gottea-search-5gtrn.ondigitalocean.app';
export const ADMIN_SESSION_KEY = 'gottea_admin_session_id';

export function getAdminSessionId() {
  return window.localStorage.getItem(ADMIN_SESSION_KEY) || '';
}

export function setAdminSessionId(sessionId) {
  if (sessionId) window.localStorage.setItem(ADMIN_SESSION_KEY, sessionId);
  else window.localStorage.removeItem(ADMIN_SESSION_KEY);
}

export async function getAdminAuthHeaders({ includeSession = true } = {}) {
  const user = auth.currentUser;
  if (!user) throw new Error('You must be signed in.');
  const token = await user.getIdToken();
  const headers = { Authorization: `Bearer ${token}` };
  const sessionId = getAdminSessionId();
  if (includeSession && sessionId) headers['X-Admin-Session-Id'] = sessionId;
  return headers;
}

export async function adminRequest(path, options = {}, requestOptions = {}) {
  const authHeaders = await getAdminAuthHeaders(requestOptions);
  const response = await fetch(`${API_BASE_URL}${path}`, {
    ...options,
    mode: 'cors',
    credentials: 'omit',
    cache: 'no-store',
    headers: {
      ...authHeaders,
      ...(options.body instanceof FormData ? {} : { 'Content-Type': 'application/json' }),
      ...(options.headers || {}),
    },
  });
  const body = await response.json().catch(() => ({}));
  if (!response.ok || body.success === false) {
    if (String(body.code || '').startsWith('admin_session_')) setAdminSessionId('');
    const error = new Error(body.error || body.message || `Request failed with status ${response.status}`);
    error.code = body.code;
    error.status = response.status;
    error.data = body.data;
    throw error;
  }
  return body.data || body;
}

export async function startAdminSession() {
  const data = await adminRequest('/admin/auth/sessions', { method: 'POST', body: JSON.stringify({}) }, { includeSession: false });
  setAdminSessionId(data.session.id);
  return data;
}

export async function fetchMyAdminAccess() {
  return adminRequest('/admin/access/me');
}

export async function loadOrCreateAdminAccess() {
  if (getAdminSessionId()) {
    try { return await fetchMyAdminAccess(); } catch (error) {
      if (error.status !== 401) throw error;
    }
  }
  return startAdminSession();
}

export async function closeAdminSession() {
  try {
    if (getAdminSessionId()) await adminRequest('/admin/auth/sessions/logout', { method: 'POST', body: JSON.stringify({}) });
  } finally {
    setAdminSessionId('');
  }
}

export function logPageView(permission, route) {
  return adminRequest('/admin/audit/page-view', { method: 'POST', body: JSON.stringify({ permission, route }) });
}
